<template>
  <!-- D: table write -->
  <div class="c-board-write">
    <div class="tr">
      <div class="th">검색</div>
      <div class="td">
        <!--
          D.
          1. data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜
          2. data-search-ui는 뒤늦게 추가된 공통 검색 ui를 동작하기위한 속성
        -->
        <div class="c-filter-search" data-search-ui data-layer-hidden>
          <div class="search-form">
            <label class="sr-only">주문검색</label>
            <input
              type="search"
              id="searchQuery"
              title="검색"
              class="search-input"
              autocomplete="off"
              placeholder="키워드 입력"
              v-model="data.search.searchKeyword"
              @keypress.enter="searchCmd('keyWord')"
            />
            <button
              type="button"
              class="search-cancel"
              @click="btnCmd('keyWordReset')"
            >
              <i class="c-icon icon-large-x"></i>
              <span class="sr-only">검색어 재입력</span>
            </button>
            <button
              type="button"
              class="search-submit"
              @click="searchCmd('search', { type: 'page' })"
            >
              <span class="sr-only">검색</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="tr">
      <div class="th">작성일</div>
      <div class="td">
        <div class="c-filter-box">
          <div class="c-form-field only-pc">
            <label class="c-input-calender">
              <input
                type="text"
                required
                title="시작일"
                data-datepicker
                ref="startDatepickerRef"
                v-model="data.search.startRegDt"
                readonly
              />
            </label>
            <span class="tilde">~</span>
            <label class="c-input-calender">
              <input
                type="text"
                required
                title="종료일"
                data-datepicker
                ref="endDatepickerRef"
                v-model="data.search.endRegDt"
                readonly
              />
            </label>
          </div>

          <div class="c-round-button-box type-mo-scroll">
            <div class="c-radio-round type-black">
              <!-- D: 처음 로딩할때 radio "1개월"로 기본 checked로 해주세요 -->
              <input
                type="radio"
                id="filter-date-option5-1"
                name="filter-date-option5"
                @change="dateCalculation('ALL')"
                value="ALL"
                v-model="data.check.chkDate"
              />
              <label for="filter-date-option5-1">전체</label>
            </div>
            <div class="c-radio-round type-black">
              <input
                type="radio"
                id="filter-date-option5-2"
                name="filter-date-option5"
                checked
                @change="dateCalculation('1M')"
                value="1M"
                v-model="data.check.chkDate"
              />
              <label for="filter-date-option5-2">1개월</label>
            </div>
            <div class="c-radio-round type-black">
              <input
                type="radio"
                id="filter-date-option5-3"
                name="filter-date-option5"
                @change="dateCalculation('6M')"
                value="6M"
                v-model="data.check.chkDate"
              />
              <label for="filter-date-option5-3">6개월</label>
            </div>
            <div class="c-radio-round type-black">
              <input
                type="radio"
                id="filter-date-option5-4"
                name="filter-date-option5"
                @change="dateCalculation('1Y')"
                value="1Y"
                v-model="data.check.chkDate"
              />
              <label for="filter-date-option5-4">1년</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tr">
      <div class="th">공지유형</div>
      <div class="td">
        <div class="c-round-button-box type-mo-scroll">
          <div class="c-radio-round type-black">
            <input
              type="radio"
              id="inquiry-radio0"
              name="inquiry-radio"
              @change="typeSwitch('ALL')"
              value="ALL"
              v-model="data.check.chkType"
            />
            <label for="inquiry-radio0">중요</label>
          </div>
          <div class="c-radio-round type-black">
            <input
              type="radio"
              id="inquiry-radio1"
              name="inquiry-radio"
              @change="typeSwitch('10')"
              value="10"
              v-model="data.check.chkType"
            />
            <label for="inquiry-radio1">제품</label>
          </div>
          <div class="c-radio-round type-black">
            <input
              type="radio"
              id="inquiry-radio2"
              name="inquiry-radio"
              @change="typeSwitch('20')"
              value="20"
              v-model="data.check.chkType"
            />
            <label for="inquiry-radio2">사이트</label>
          </div>
          <div class="c-radio-round type-black">
            <input
              type="radio"
              id="inquiry-radio3"
              name="inquiry-radio"
              @change="typeSwitch('30')"
              value="30"
              v-model="data.check.chkType"
            />
            <label for="inquiry-radio3">유해화학</label>
          </div>
          <div class="c-radio-round type-black">
            <input
              type="radio"
              id="inquiry-radio4"
              name="inquiry-radio"
              @change="typeSwitch('40')"
              value="40"
              v-model="data.check.chkType"
            />
            <label for="inquiry-radio4">기타</label>
          </div>
        </div>
      </div>
    </div>
    <div class="tr">
      <div class="th">확인여부</div>
      <div class="td">
        <div class="c-check-field">
          <div class="c-radio">
            <input
              type="radio"
              id="raido1"
              name="raidogroup"
              checked
              value=""
              v-model="data.check.idntyYn"
            />
            <label for="raido1">전체</label>
          </div>
          <div class="c-radio">
            <input
              type="radio"
              id="raido2"
              name="raidogroup"
              value="N"
              v-model="data.check.idntyYn"
            />
            <label for="raido2"
              >확인전(<span class="type-confirm color-danger">N</span>)</label
            >
          </div>
          <div class="c-radio">
            <input
              type="radio"
              id="raido3"
              name="raidogroup"
              value="Y"
              v-model="data.check.idntyYn"
            />
            <label for="raido3"
              >확인완료(<span class="type-confirm color-primary">Y</span
              >)</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- // D: table write -->

  <div class="c-btn-area has-customer-submit">
    <button
      type="button"
      class="c-util-button type-line-black"
      @click="btnCmd('reset')"
    >
      <span>초기화</span>
    </button>
    <button
      type="button"
      class="c-util-button type-primary"
      @click="searchCmd('search', { type: 'page' })"
    >
      <span>조회</span>
    </button>
  </div>

  <!-- D: 공지사항 목록 -->
  <!-- D: MO에서 아코디언 펼침이 아닌 레이어팝업으로 호출 필요 -->
  <div class="c-notice-list" data-accordion-wrap data-mo-prevent>
    <div class="head">
      <div class="th" style="--tb-width: 11%">공지유형</div>
      <div class="th" style="--tb-width: 500px">제목</div>
      <div class="th" style="--tb-width: 11%">작성일</div>
      <div class="th" style="--tb-width: 11%">조회수</div>
      <div class="th" style="--tb-width: 11%">확인여부</div>
      <div class="th" style="--tb-width: 11%">펼침</div>
    </div>
    <div class="body">
      <div
        class="item"
        v-for="(item, idx) in data.notice.list"
        :key="idx"
        :id="'ID' + item.ntcMttrSn"
      >
        <button
          type="button"
          class="accordion-button"
          data-accordion-trigger
          :aria-expanded="data.notice.expendIndex === idx"
          :aria-controls="'act' + idx"
          @click="
            data.page.deviceType == 'P'
              ? btnCmd('expendClick', {
                  index: idx,
                  ntcMttrSn: item.ntcMttrSn,
                  idntyYn: item.idntyYn,
                })
              : popCmd({
                  index: idx,
                  ntcMttrSn: item.ntcMttrSn,
                  idntyYn: item.idntyYn,
                  info: item,
                })
          "
        >
          <div style="display: none">
            파람sn {{ data.route.combnCrcolnQstnSn }} | 펼침인덱스:{{
              data.notice.expendIndex
            }}
            | 행sn{{ item.combnCrcolnQstnSn }} |
          </div>
          <div class="td" style="--tb-width: 11%">
            <span v-if="item.imptYn == 'Y'" class="c-flag type-board type-red"
              >중요</span
            >
            <span
              v-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '10'"
              class="c-flag type-board type-green"
              >제품</span
            >
            <span
              v-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '20'"
              class="c-flag type-board type-purple"
              >사이트</span
            >
            <span
              v-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '30'"
              class="c-flag type-board type-blue"
              >유해화학</span
            >
            <span
              v-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '40'"
              class="c-flag type-board type-olive"
              >기타</span
            >
          </div>
          <div class="td al" style="--tb-width: 500px">
            <strong
              class="title"
              v-html="sanitizeHTML(item.ntcMttrTitleNm)"
            ></strong>
          </div>
          <div class="td" style="--tb-width: 11%">
            <span class="date">{{ item.regDt }}</span>
          </div>
          <div class="td" style="--tb-width: 11%">
            <span class="hits">{{ item.inqCnt }}</span>
          </div>
          <div class="td" style="--tb-width: 11%">
            <span class="confirm">
              <span
                :class="item.idntyYn == 'Y' ? 'color-primary' : 'color-danger'"
                >{{ item.idntyYn }}</span
              >
            </span>
          </div>
          <div class="td" style="--tb-width: 11%"></div>
        </button>
        <div
          v-if="data.page.deviceType == 'P'"
          :id="'act' + idx"
          class="accordion-content"
          data-accordion-content
          :aria-hidden="data.notice.expendIndex !== idx"
        >
          <div class="text" v-html="sanitizeHTML(item.ntcMttrCn)"></div>
          <div class="file-down-guide" v-if="item.fileSn != 0">
            관련 파일 다운로드 <br /><br />
            파일명 :
            <a
              href="javascript:void(0);"
              class="color-primary hover-underline"
              @click="btnCmd('fileDown', { info: item })"
              >{{ item.orgnlFileNm }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- // D: 공지사항 목록 -->

  <!-- D: no data -->
  <div class="c-no-data-box" v-if="!data.notice.listFlag">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">조회 결과가 없습니다.</p>
  </div>

  <!-- D : pageing area -->
  <template v-if="data.notice.listFlag">
    <Pagination
      ref="paginationEl"
      :total-pages="data.notice.totalPage"
      :per-page="data.notice.limit"
      :show-select="true"
      :page-reload-flag="data.notice.pageReloadFlag"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
    />
  </template>
  <!-- // D : pageing area -->

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <moNoticeDetailPop
    v-if="data.popup.isNoticePop"
    :data="data.popup.info"
    @close="closePop()"
  />
</template>
<script setup name="noticeTab">
import {
  onMounted,
  reactive,
  inject,
  ref,
  computed,
  provide,
  watch,
  nextTick,
} from "vue";
import { useRoute } from "vue-router";
import { api } from "@/plugins/api";

import Pagination from "@/components/paintpro/base/pagination.vue";
import moNoticeDetailPop from "@/components/paintpro/custCenter/moNoticeDetailPop.vue";
import $ from "jquery";

import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const url = inject("url_prefix");
const startDatepickerRef = ref(null);
const endDatepickerRef = ref(null);
const paginationEl = ref(null);
const route = useRoute();
const { isMobile } = cmUtil.useDeviceType();

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    empIndex: 0,
    deviceType: isMobile.value ? "M" : "P",
  },
  notice: {
    listFlag: true,
    expendIndex: -1,
    list: [],
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    pageReloadFlag: 0,
    loading: false,
  },
  search: {
    startRegDt: "",
    endRegDt: "",
    searchKeyword: null,
  },
  check: {
    chkDate: "",
    chkType: "",
    idntyYn: "",
  },
  route: {
    ntcMttrSn: 0,
  },
  popup: {
    isNoticePop: false,
    info: {},
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  jqueryDatepicker(); // 달력
  dateCalculation("6M");
  pageInit(); // 초기셋팅
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  data.route.ntcMttrSn = route.params.id;
  if (data.route.ntcMttrSn > 0) {
    data.notice.limit = 100;
    await searchCmd("search", { type: "route" });
    data.notice.pageReloadFlag++;
  } else {
    await searchCmd("search", { type: "page" });
  }

  goToSelectedPost();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  const mparm = [];

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;
}

const datePair = computed(() => [data.search.startRegDt, data.search.endRegDt]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.search.startRegDt = oldStartDate;
      data.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.</br> 다시 확인해주세요."
      );
    }
  }
);

watch(
  () => route.params.id,
  async (newValue) => {
    data.notice.expendIndex = -1;
    data.route.ntcMttrSn = newValue;
    data.notice.limit = 100;
    await searchCmd("search", { type: "route" });
    goToSelectedPost();
    data.notice.pageReloadFlag++;
  }
);

/**********************
 * 버튼 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 아코디언 활성화
  if (cmd === "expendClick") {
    if (data.notice.expendIndex == params.index) {
      data.notice.expendIndex = -1;
    } else {
      data.notice.expendIndex = params.index;

      searchCmd("update", {
        ntcMttrSn: params.ntcMttrSn,
        index: params.index,
        idntyYn: params.idntyYn,
      });
    }
  }
  // 주문 건 선택
  else if (cmd == "fileDown") {
    cmApi.fileDownload(params.info);
  }
  // 초기화
  else if (cmd == "reset") {
    data.search.searchKeyword = null;
    data.check.chkDate = "6M";
    await dateCalculation("6M");
    data.check.chkType = "";
    data.check.idntyYn = "";
  } else if (cmd == "keyWordReset") {
    data.search.searchKeyword = null;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  if (cmd === "search") {
    const res = await api.post(`${url}/custCenter/selectCust03`, {
      ntcMttrTypeCd: data.check.chkType == "ALL" ? null : data.check.chkType,
      searchKeyword: data.search.searchKeyword,
      idntyYn: data.check.idntyYn,
      startRegDt: data.search.startRegDt,
      endRegDt: data.search.endRegDt,
      page: params["page"] || 1,
      limit: params["limit"] || data.notice.limit,
      ntcMttrMrktAll:
        params.initAll != null
          ? params.initAll
          : data.check.chkType == "ALL"
            ? "ALL"
            : null,
      ntcMttrMrktCd:
        data.page.userLoginInfo.empList[
          store.useEventBusStore().salesPersonIndex
        ]?.matkl,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    //메인화면에서 공지사항 글을 선택 후 넘어오는 경우
    if (params.type == "route") {
      if (data.route.ntcMttrSn > 0) {
        for (let i in res.data.list) {
          if (res.data.list[i].ntcMttrSn == data.route.ntcMttrSn) {
            if (data.page.deviceType == "P") {
              data.notice.expendIndex = Number(i);
              searchCmd("update", {
                ntcMttrSn: data.route.ntcMttrSn,
                index: Number(i),
                idntyYn: "N",
              });
            } else {
              popCmd({
                index: Number(i),
                ntcMttrSn: data.route.ntcMttrSn,
                idntyYn: "N",
                info: res.data.list[i],
              });
            }
            break;
          }
        }
      }
    } else {
      data.notice.expendIndex = -1;
    }

    data.notice.list = res.data.list;
    data.notice.page = params["page"] || 1;
    data.notice.totalCount = res.data.totalCount;
    data.notice.totalPage = data.notice.totalCount
      ? Math.ceil(data.notice.totalCount / data.notice.limit)
      : 0;

    if (res.data.totalCount > 0) {
      data.notice.listFlag = true;
    } else {
      data.notice.listFlag = false;
    }
  } else if (cmd == "keyWord") {
    if (data.search.searchKeyword.length > 0) {
      searchCmd("search", { type: "page" });
    }
  }
  // 조회한 공지사항 게시물 조회수 및 확인 여부 업데이트
  else if (cmd == "update") {
    const res = await api.post(`${url}/custCenter/updateInqCnt`, {
      ntcMttrSn: params.ntcMttrSn,
      type: "notice",
    });

    // 해당 게시물 확인 여부 체크
    const inqres = await cmApi.updateUserPstInqHist({
      pstNo: params.ntcMttrSn,
      pstSeCd: "NTC",
    });

    // 조회수
    if (res.resultCode == 200) {
      if (res.data > 100000) {
        data.notice.list[params.index].inqCnt = "9999+";
      } else {
        data.notice.list[params.index].inqCnt = res.data;
      }
    }

    // 확인여부
    if (inqres.resultCode == 200) {
      if (params.idntyYn == "N") {
        data.notice.list[params.index].idntyYn = "Y";
      }
    }
  }
}

/**********************
 * 팝업 모음
 *********************/
async function popCmd(params = {}) {
  searchCmd("update", {
    ntcMttrSn: params.ntcMttrSn,
    index: params.index,
    idntyYn: params.idntyYn,
  });

  data.popup.isNoticePop = true;
  data.popup.info = params.info;
}

/**********************
 * 팝업 닫기
 *********************/
const closePop = () => {
  data.popup.isNoticePop = false;
};

provide("closePop", closePop);

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  searchCmd("search", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.notice.limit = perPage;
  searchCmd("search", { type: "page" });
}

/**********************
 * jquery 달력
 *********************/
async function jqueryDatepicker() {
  if (startDatepickerRef.value == null) return;
  $(startDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "-1D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.startRegDt = dateText;
      data.check.chkDate = "";
    },
  });

  // 종료일
  if (endDatepickerRef.value == null) return;
  $(endDatepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: "0D",
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.search.endRegDt = dateText;
      data.check.chkDate = "";
    },
  });
}

/**********************
 * 등록일 버튼 모음
 *********************/
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);

  switch (period) {
    case "ALL":
      break;
    case "1M":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "6M":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "1Y":
      resultDate.setDate(today.getDate() - 364);
      break;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);

  if (period == "ALL") {
    data.search.startRegDt = "";
    data.search.endRegDt = "";
  } else {
    data.search.startRegDt = resultDate;
    data.search.endRegDt = todayDate.value;
  }
  data.check.chkDate = period;
}

/**********************
 * 공지유형
 *********************/
async function typeSwitch(type) {
  data.check.chkType = type;
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}

// 공지사항 열린 위치로 스크롤 이동
const goToSelectedPost = () => {
  nextTick(() => {
    const id = route.params.id || "";
    if (id) {
      const idEl = document.getElementById(`ID${id}`);
      let positionTop = idEl?.getBoundingClientRect().top || 0;
      if (positionTop > 100) {
        positionTop -= 95;
      }
      window.scroll({ top: positionTop });
    }
  });
};
</script>
<style scoped></style>
